import { User } from '@core/redux/stores/user.store';

export abstract class FeatureFlagService {
  abstract isInitialized: boolean;

  abstract checkGate(gateName: string): boolean;

  abstract getConfigValue<T>(configName: string, paramName: string, defaultValue: T): T;

  abstract getExperimentValue<T>(experimentName: string, paramName: string, defaultValue: T): T;

  /**
   * Gets a value from a layer (grouped parameters). Returns defaultValue when no layer match exists.
   */
  abstract getLayerValue<T>(layerName: string, paramName: string, defaultValue: T): T;

  abstract logEvent(eventName: string, value?: string | number, metadata?: Record<string, string>): void;

  /**
   * Rebuilds the Statsig user from the provided auth context and pushes it to the SDK.
   * Call this on login, logout, or any auth state change.
   */
  abstract updateUser(user?: User | null): void;

  /**
   * Rebuilds the Statsig user from the last known auth context (e.g. after device fingerprint resolves).
   */
  refreshUser(): void {
    // no-op for implementations that do not track last user
  }

  /**
   * Pushes queued events out now instead of waiting for the next batch. Only worth calling while the
   * page is unloading, where the pending batch would otherwise be cancelled with the page.
   */
  flush(): void {
    // no-op for implementations that do not batch
  }
}
